import { ChangeDetectionStrategy, Component, DestroyRef, inject, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { RolesService } from '../roles.service';
import { Role } from '@helpers/types/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-role-delete-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class RolesDeleteDialogComponent {

	private destroyRef = inject(DestroyRef);

	constructor(
		@Inject(DIALOG_DATA) public data: { role: Role },
		public rolesService: RolesService,
		private dialogRef: DialogRef<boolean>
	) {
	}

	confirm(): void {
		this.rolesService.delete({ id: this.data.role.ID! })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp.Deleted ) {
					this.dialogRef.close(true);
				}
			});
	}

	close(): void {
		this.dialogRef.close(false);
	}

}
